const en = {
  common: {
    actions: {
      close: 'Close',
      accept: 'Accept',
      back: 'Back',
      continue: 'Continue',
    },
    errors: {
      title: 'Error',
      unknown: 'Unknown error.',
    },
    fields: {
      email: 'Email',
      firstName: 'First name',
      lastName: 'Last name',
      country: 'Country',
      city: 'City',
      postalCode: 'Postal code',
      password: 'Password',
      confirmPassword: 'Confirm password',
      companyName: 'Company name',
      userType: 'User type',
      vatId: 'VAT ID',
      cif: 'CIF',
      nifNie: 'NIF/NIE',
    },
    userTypes: {
      person: 'Self-employed',
      company: 'Company',
    },
  },

  paymentCancelled: {
    title: 'Payment cancelled',
    description: 'The payment process has been cancelled. If it was a mistake, you can try again.',
  },

  paymentSuccess: {
    title: 'Payment completed successfully!',
    descriptionDemo: 'You can now <link>log in</link> and enjoy all the benefits of our platform.',
    descriptionStandard:
      'We have sent an email with the details of your subscription. Please check your inbox and follow the instructions to complete the process.',
  },

  registration: {
    title: 'Start registration',
    titleDemo: 'Start demo registration',
    complete: 'Complete',
    stepsCount: '3 steps',
    toCreateAccount: 'to create your account',
    planFallback: 'Plan',
    planSelection: 'Plan selection',
    expensesTotalUsers: 'Total: {{total}} Billivo Expenses users ({{base}} included in the plan)',
    inviteApplied:
      'Invitation from your accountant applied: 50 EUR off the yearly Business Advance + Acceso al Contable plan.',
    inviteRequiresPlan:
      'Your accountant invites you with 50 EUR off. The discount applies to the Business Advance + Acceso al Contable plan with yearly billing.',

    steps: {
      account: 'Account',
      userData: 'User data',
      addressAndConfirmation: 'Address and confirmation',
      planAndAccount: 'Plan and account',
    },

    userTypes: {
      person: 'Self-employed',
      company: 'Company',
      agent: 'Agent',
    },

    fields: {
      subscriptionPlan: 'Subscription plan',
      billingPeriod: 'Billing period',
      expensesPacks: 'Extra Billivo Expenses packs (10 users each)',
      userType: 'User type',
      companyName: 'Company name',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm password',
      cif: 'CIF',
      nifNie: 'NIF/NIE',
      vatId: 'VAT ID',
      phoneNumber: 'Phone number',
      taxType: 'Tax type',
      addressLine1: 'Address line 1',
      addressLine2: 'Address line 2',
      postalCode: 'Postal code',
      city: 'City',
      country: 'Country',
      discountCode: 'Discount code',
      referredByCode: 'Referral code',
      agentName: 'Agent name',
      agentDocument: 'NIF/CIF/NIE',
      agentVatId: 'VAT ID',
      agentPhoneNumber: 'Phone number',
      agentWebsite: 'Website',
      referralOptIn: 'Do you want to participate in the agent referral system?',
    },

    billing: {
      monthly: 'Monthly',
      yearly: 'Yearly',
      popular: 'Popular',
      save17: 'Save 17%',
      monthShort: 'mo',
      yearShort: 'yr',
    },

    taxTypes: {
      peninsula: '01 - Mainland Spain',
      ceutaMelilla: '02 - Ceuta and Melilla',
      canaryIslands: '03 - Canary Islands',
      other: '05 - Others',
    },

    api: {
      devOnly: '⚙️ [DEVELOPERS ONLY]',
      useApi: 'I want to use the Billivo API',
      numberingManagement: 'Numbering management',
      selectOption: 'Select an option',
      erpOption: 'I want to manage invoice numbering myself',
      noErpOption: 'I want Billivo to manage numbering',
    },

    accessibility: {
      showPassword: 'Show password',
      hidePassword: 'Hide password',
      showConfirmPassword: 'Show confirmation',
      hideConfirmPassword: 'Hide confirmation',
    },

    actions: {
      continue: 'Continue',
      back: 'Back',
      sending: 'Sending...',
      finishRegistration: 'Complete registration',
      close: 'Close',
      accept: 'Accept',
    },

    status: {
      sendingInfo: 'Sending information...',
    },

    errors: {
      title: 'Error',
      unknown: 'Unknown error.',
      submitUnknown: 'Unknown error while submitting the form',
      stripeLoadFailed: 'Stripe could not be loaded.',
      noSession: 'There is no session to redirect to',
    },

    validation: {
      invalidWebsite: 'Invalid website',
      validOption: 'Select a valid option',
      apiUsageTypeRequired: 'Select how numbering should be managed',
      emailRequired: 'Email is required',
      invalidEmail: 'Invalid email',
      companyNameRequired: 'Company name is required',
      firstNameRequired: 'First name is required',
      lastNameRequired: 'Last name is required',
      nationalIdRequired: 'NIF/NIE/CIF is required',
      invalidDocument: 'Invalid document',
      invalidCif: 'Invalid CIF',
      invalidNifNie: 'Invalid NIF/NIE',
      taxTypeRequired: 'Tax type is required',
      phoneRequired: 'Phone number is required',
      addressRequired: 'Address is required',
      postalCodeRequired: 'Postal code is required',
      cityRequired: 'City is required',
      countryRequired: 'Country is required',
      billingPeriodRequired: 'Billing period is required',
      passwordRequired: 'Password is required',
      passwordMin: 'Minimum 8 characters',
      confirmPasswordRequired: 'Please confirm your password',
      passwordsDoNotMatch: 'Passwords do not match',
      maxLength: 'Maximum {{max}} characters',
      maxValue: 'Maximum {{max}}',
    },

    terms: {
      acceptPrefix: 'I accept the',
      linkText: 'terms and conditions',
      title: 'Terms and Conditions',
      sections: {
        general: {
          title: '1. General information and acceptance',
          body: 'These terms and conditions govern access to and use of Billivo.',
        },
        definitions: {
          title: '2. Definitions',
          body: 'User: natural person who uses Billivo. Services: functionalities offered through Billivo. Content: any information or material available on Billivo.',
        },
        scope: {
          title: '3. Purpose and scope',
          body: 'Billivo allows users to access the services offered by the company.',
        },
        access: {
          title: '4. Registration and access',
          body: 'It may be necessary to register and create an account using truthful and up-to-date information.',
        },
        usage: {
          title: '5. Use of Billivo',
          body: 'The user agrees to use Billivo lawfully and in good faith.',
        },
        privacy: {
          title: '6. Privacy and data protection',
          body: 'The collection and processing of personal data is governed by the applicable regulations in force.',
        },
        communications: {
          title: '7. Commercial communications and newsletters',
          body: 'By accepting these terms, the user authorizes certain communications related to Billivo.',
        },
        intellectualProperty: {
          title: '8. Intellectual and industrial property',
          body: 'All rights over Billivo and its contents belong to the company or to authorized third parties.',
        },
        liability: {
          title: '9. Disclaimer of warranties and liability',
          body: 'The company does not guarantee the continuous availability of Billivo in all cases.',
        },
        thirdPartyLinks: {
          title: '10. Links to third-party sites',
          body: 'Billivo may include links to third-party sites, without being responsible for their content.',
        },
        modifications: {
          title: '11. Modification of the Terms',
          body: 'The company may modify these terms whenever it considers it necessary.',
        },
        termination: {
          title: '12. Termination',
          body: 'The company may suspend or cancel access in the event of breach or fraudulent use.',
        },
        jurisdiction: {
          title: '13. Governing law and jurisdiction',
          body: 'These terms are governed by Spanish law.',
        },
        contact: {
          title: '14. Contact',
          body: 'For any questions, the user may contact the company by email.',
        },
      },
    },
  },

  registrationSuccess: {
    title: 'Registration completed successfully!',
    descriptionDemo: 'You can now <link>log in</link> and enjoy all the benefits of our platform.',
    descriptionStandard:
      'We have sent an email with the details of your registration. Please check your inbox and follow the instructions to complete the process.',

    apiCredentials: {
      title: 'API Credentials - IMPORTANT!',
      warning:
        'This password has <strong>NOT been saved</strong> and will only be shown once. Save it in a secure place before leaving this page.',
      emailLabel: 'Email:',
      passwordLabel: 'Password:',
    },

    snackbar: {
      copied: '{{field}} copied to clipboard',
      email: 'Email',
      password: 'Password',
    },
  },

  simpleForm: {
    title: 'Quick registration',
    subtitle: 'Complete the form and at the end we will show you your QR code.',
    optional: 'Optional',
    fields: {
      country: 'Country',
      userType: 'User type',
      firstName: 'First name',
      lastName: 'Last name',
      companyName: 'Company name',
      email: 'Email',
      vatId: 'VAT ID',
      cif: 'CIF',
      nifNie: 'NIF/NIE',
      taxId: 'Tax identification number',
      taxIdOptional: 'Tax identification number (optional)',
    },
    userTypes: {
      person: 'Self-employed',
      company: 'Company',
    },
    helpers: {
      companyCif: 'Enter the company CIF',
      personNifNie: 'Enter your NIF or NIE',
      euRequired: 'This field is required for EU customers',
      outsideEuOptional: 'You can complete it if you have a tax identification number',
    },
    validation: {
      countryRequired: 'Country is required',
      userTypeRequired: 'User type is required',
      emailRequired: 'Email is required',
      invalidEmail: 'Invalid email',
      companyNameRequired: 'Company name is required',
      firstNameRequired: 'First name is required',
      lastNameRequired: 'Last name is required',
      nationalIdRequiredSpain: 'NIF/NIE/CIF is required',
      invalidDocument: 'Invalid document',
      invalidCif: 'Invalid CIF',
      invalidNifNie: 'Invalid NIF/NIE',
      taxIdRequired: 'Tax identification number is required',
    },
    actions: {
      register: 'Register',
      registering: 'Registering...',
      close: 'Close',
      accept: 'Accept',
    },
    status: {
      sending: 'Sending information...',
    },
    errors: {
      title: 'Error',
      unknownError: 'Unknown error.',
      submitError: 'Unknown error while submitting the form',
    },
    terms: {
      acceptPrefix: 'I accept the',
      linkText: 'terms and conditions',
      title: 'Terms and Conditions',
      sections: {
        general: {
          title: '1. General information and acceptance',
          body: 'These terms and conditions (the "Terms") govern access to and use of the mobile and/or web application (hereinafter Billivo) developed by Code10 IT Consultants S.L. If you do not agree with the Terms, do not use Billivo.',
        },
        definitions: {
          title: '2. Definitions',
          body: 'User: the natural person who, upon accepting these Terms, uses Billivo regardless of whether acting on their own behalf or on behalf of a third party.',
        },
        scope: {
          title: '3. Purpose and scope',
          body: 'Billivo allows Users to access the Services offered by the company. The use of Billivo is personal and non-commercial.',
        },
        access: {
          title: '4. Registration and access',
          body: 'To use certain Services it may be necessary to register and create an account, providing truthful and updated information. The User is responsible for safeguarding their credentials.',
        },
        usage: {
          title: '5. Use of Billivo',
          body: 'The User agrees to use Billivo lawfully, in good faith, and without violating the legal system.',
        },
        privacy: {
          title: '6. Privacy and data protection',
          body: 'The collection and processing of personal data are governed by the Privacy Policy and the applicable regulations in force.',
        },
        communications: {
          title: '7. Commercial communications and newsletters',
          body: 'By accepting these Terms and registering with Billivo, the User expressly authorizes the company to use their email address and other contact details to send communications.',
        },
        intellectualProperty: {
          title: '8. Intellectual and industrial property',
          body: 'All intellectual and industrial property rights over Billivo, its source code, design, contents, logos, and trademarks belong to the company or to third parties who have authorized their use.',
        },
        liability: {
          title: '9. Disclaimer of warranties and liability',
          body: 'The company does not guarantee the availability, continuity, or infallibility of Billivo and is exempt from liability to the extent permitted by law.',
        },
        thirdPartyLinks: {
          title: '10. Links to third-party sites',
          body: 'Billivo may include links to third-party websites or content. The company does not control these sites and is not responsible for their content.',
        },
        modifications: {
          title: '11. Modification of the Terms',
          body: 'The company may modify these Terms whenever it considers it necessary. The modifications will enter into force from their publication.',
        },
        termination: {
          title: '12. Termination',
          body: 'The company may suspend or cancel the User’s access when detecting breaches, fraudulent use, or use contrary to law.',
        },
        jurisdiction: {
          title: '13. Governing law and jurisdiction',
          body: 'These Terms are governed by Spanish law. For the resolution of disputes, the parties submit to the competent courts and tribunals.',
        },
        contact: {
          title: '14. Contact',
          body: 'For any questions or inquiries, the User may contact the company by sending an email to support@billivo.com.',
        },
      },
    },
  },

  simpleFormSuccess: {
    notFound: {
      title: 'Registration not found',
      description: 'We do not have enough information to display the QR code.',
      backButton: 'Back to form',
    },
    success: {
      title: 'Registration completed successfully!',
      description:
        'Your user has been created successfully. Save this QR code and show it to the driver so they can issue your invoice.',
    },
    temporaryPassword: {
      title: 'Temporary password',
      description:
        'This password has been generated automatically and must be changed on first login.',
      emailLabel: 'Email:',
      passwordLabel: 'Temporary password:',
    },
    snackbar: {
      copied: '{{field}} copied to clipboard',
      email: 'Email',
      temporaryPassword: 'Temporary password',
    },
  },
};

export default en;
